<template>
  <div>
    <modal :size="'modal-small'" :close-strict="true" @close="$emit('close')">
      <div slot="header">
        <h4>Send E-pay Link</h4>
      </div>
      <div class="modal-body-scroll" slot="body">
        <div class="loader-circle" v-show="loading" />
        <div v-if="!showConfirmation" class="row send-epay-wrapper">
          <div class="col-md-12 text-center mb-3">
            <h5 class="font-weight-bold">How do you wish to send the link?</h5>
          </div>
          <div class="col-md-12 text-center mb-2">
            <div class="form-row">
              <div class="col-6 pt-2 pl-0 cc-n-umber radio-button-wrap ml-3">
                <label
                  @click="setVia('email')"
                  class="pointer text-left w-100 h-100 d-flex align-items-center"
                >
                  <input :checked="sendVia === 'email'" type="radio" id="email" />
                  <span class="btn-radio" />
                  <label for="email" class="btn-radio-label">Email</label>
                </label>
              </div>
              <div class="col-6 pt-2 pl-0 cc-n-umber radio-button-wrap ml-3">
                <label
                  @click="setVia('SMS')"
                  class="pointer text-left w-100 h-100 d-flex align-items-center"
                >
                  <input :checked="sendVia === 'SMS'" type="radio" id="sms" />
                  <span class="btn-radio" />
                  <label for="sms" class="btn-radio-label">SMS</label>
                </label>
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center send-epay-actions mt-4">
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-secondary" @click="$emit('close')">
                Cancel
              </button>
            </div>
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-primary" @click="showConfirmation = true">
                Send
              </button>
            </div>
          </div>
        </div>
        <div v-else class="row send-epay-wrapper" :class="[loading ? 'opacity-2' : '']">
          <div class="col-md-12 text-center mb-3">
            <h5 class="font-weight-bold">
              Are you sure you want to send an e-pay link via {{ sendVia }} for the remaining
              balance of ${{ job.remaining_price }}?
            </h5>
          </div>
          <div class="col-md-12 text-center send-epay-actions mt-4">
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-secondary" @click="showConfirmation = false">
                No, go back
              </button>
            </div>
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-primary" @click="sendLink">
                Yes, send link
              </button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" />
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Modal from '../../Modal';

export default {
  name: 'SendEpayLink',
  components: {
    Modal,
  },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    loading: false,
    sendVia: 'email',
    showConfirmation: false,
  }),
  methods: {
    setVia(value) {
      this.sendVia = value;
    },
    sendLink() {
      this.loading = true;
      axios
        .post(`jobs/${this.job.id}/epay`, { channel: this.sendVia })
        .then(() => {
          toastr.success('E-pay link sent');
          this.$emit('close');
          this.showConfirmation = false;
        })
        .catch(() => {
          toastr.error('Error sending link');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.send-epay-wrapper {
  padding: 15px 15px 0 15px;
}
.send-epay-actions {
  display: flex;
  justify-content: space-around;
}
.opacity-2 {
  opacity: 0.2;
}
.loader-circle {
  margin-bottom: 30px;
  border: 3px solid rgba(0, 0, 0, 0);
  border-left-color: #2962ff;
  -webkit-animation: loader-spin 1.2s infinite linear;
  animation: loader-spin 0.7s infinite linear;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  z-index: 10000;
  position: absolute;
  top: 43%;
  right: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/modals/SendEpayLink.vue